import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  container: {
    margin: '10px 0',
    '& *': {
      padding: '3px 0',
    },
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },

  ruleTitle: {
    fontSize: '15px',
    lineHeight: '15px',
  },

  bottomText: {
    fontSize: '18px',
    lineHeight: '18px',
    textAlign: 'center',
  },

  rule: {
    padding: '15px',
    margin: '15px 5px',
    background: '#FFFFFF',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.7)',
    borderRadius: '20px',
    '&:hover': {
      boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.8)',
    },
    cursor: 'pointer',
  },

  body: {
    maxHeight: '300px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0',
  },

  content: {
    overflowY: 'auto',
  },

  nextButton: (props: { baseColors: BaseColors }) => {
    return {
      display: 'flex',
      margin: '10px',
      padding: '5px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      width: '50%',
      borderRadius: '15px',
      backgroundColor: props.baseColors.secondary,
      cursor: 'pointer',
      color: '#ffffff',
    }
  },

  nextButtonSpan: {
    display: 'inline-block',
    letterSpacing: '0.05em',
    lineHeight: '38px',
    fontSize: '25px',
    fontFamily: 'Mulish',
  },

  disabledButton: () => {
    return {
      backgroundColor: '#E7E7E7',
      color: '#111',
    }
  },

  checkbox: {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
  },

  showIcon: {
    paddingLeft: '10px',
    marginLeft: 'auto',
    cursor: 'pointer',
  },
}))

export default buildStyles
